import type { IdpState } from './types';

import type { StateCreator } from '@shared-types/zustand.types';

export const idpSlice: StateCreator<IdpState> = (set) => ({
  isIdpReady: false,
  setIsIdpReady: () => set(() => ({ isIdpReady: true }), false, 'setIsIdpReady'),
});
